import {connect} from 'react-redux'
import CheckReview from '../components/CheckReviewView'

import { cancelTransaction, approveTransaction } from "../modules/checkcashing";

const mapDispatchToProps = {
  cancelTransaction,
  approveTransaction
};

const mapStateToProps = (state) => {
  return {

  }
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckReview)


// WEBPACK FOOTER //
// ./src/components/Applications/CheckCashing/containers/CheckReviewContainer.js